import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.192",
  height: "17.576"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g data-name=\"Ikona MENU Klienci\"><g data-name=\"Group 12937\"><g data-name=\"Group 12932\"><g fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"1.5\" data-name=\"Group 12929\" transform=\"translate(.752 .824)\"><path d=\"M14 16c-.01-3.3-2.162-5.969-4.816-5.969H4.816C2.162 10.031.009 12.702 0 16\" data-name=\"Path 16542\"></path><circle cx=\"3.5\" cy=\"3.5\" r=\"3.5\" data-name=\"Ellipse 394\" transform=\"translate(3.506)\"></circle><path d=\"M20.688 15.964c-.009-3.291-2.114-5.956-4.709-5.956h-.708\" data-name=\"Path 16549\"></path><path d=\"M12.14.439s2.316-1.162 4.049.367a3.55 3.55 0 0 1 .258 5.01 4.54 4.54 0 0 1-3.143 1.057\" data-name=\"Path 16550\"></path></g></g></g></g>", 1)
  ]))]))
}
export default { render: render }